<template>
  <v-container text-xs-center class="coverImg mx-0 px-0">
    <v-row  justify="space-between" class="mx-0 mt-0 pt-0 pt-0 pb-0">
      <v-col cols=2>
      </v-col>
      <v-col cols=2>
        <changeLocaleBtn :loginPage="true" />
      </v-col>
    </v-row>
    <v-row style="position:absolute;height:50vh;width:100%;max-width:700px;margin-right: auto;margin-left: auto;">
      <v-col cols=12 align=center class="white--text px-16 pt-10">
        {{$t("welcome")}}<br />
        {{$t("letsDiscoverNewStoriesAndExperience")}}
      </v-col>
      <v-col cols=12 lg="12" sm="12" align="center" class="mt-0">

        <v-btn color="secondaryVariant" class="btn2  pt-5 pb-5 px-15" :disabled="!termsandcondition" @click.prevent="loginAsGuest" type="submit"
          id="Login">
          {{$t('viewStories')}}</v-btn>
      </v-col>
    
    </v-row>

<div class="whiteFooter">

</div>
    <v-row style="position:absolute;bottom:0px;height:30vh;z-indez:2;width:100vw;max-width: 700px;" align="center" justify="center" class="mx-0 mt-3 mb-3">
      <v-col align="center" cols=12>
        {{$t('doYouWantToWriteAStory')}}
      </v-col>
      <v-col cols=12 lg="12" xs="12" align="center" class="mx-3 mt-0">
        <v-btn  class="btn1 px-15 pt-5 pb-5" :disabled="!termsandcondition"
          @click.prevent="goToAuthorLogin" type="submit" id="Login">
          {{$t('loginAuthor')}}</v-btn>
      </v-col>
            <v-col align="center" cols="6" class="mx-0  px-0 pt-0 pb-0">
        <v-tooltip color="primaryVariant" v-model="isTooltipOpen" top v-if="termsandcondition!=true">
          <template v-slot:activator="{ on, attrs }">

            <div v-bind="attrs" v-on="on">
              <v-btn style="white-space: nowrap;" class="px-0 mx-0 text-capitalize fontsize" text @click="gotopage('termsAndConditions')">
                {{$t('termsAndConditionsTitle')}}

              </v-btn>
            </div>
          </template>
          <span>{{$t('PleaseAgreeTermsAndCondition')}}</span>
        </v-tooltip>
        <v-btn v-else style="white-space: nowrap;" class="text-capitalize fontsize " text @click="gotopage('termsAndConditions')">
          {{$t('termsAndConditionsTitle')}}

        </v-btn>

      </v-col>

      <v-col col=6 class="mx-0 px-0 pt-0 pb-0 fontsize text-right pr-0">
        <privacyPolicies />
      </v-col>

    </v-row>

  </v-container>
</template>

<script>

import privacyPolicies from "@/components/privacyPolicies";
//import termsAndConditions from "@/components/termsAndConditions";
import changeLocaleBtn from "@/components/changeLanguageBtn.vue"

export default {
  name: "Login",
  data() {
    return {
      value: String,
      isTooltipOpen:true,
      haveToSaveCredentials:false,
      selectedRoleValue: null,
      allRoles: [],
      apiUrl: process.env.VUE_APP_ROOT_API,
      apiStrapi: process.env.VUE_APP_ROOT_STRAPI,
      username: "",
      password: "",
      submitted: false
    };
  },
  components:{
  // termsAndConditions,
    changeLocaleBtn,
    privacyPolicies
  },
  mounted: function() {
    //all language
    //italian it-IT
    //catalan ca
    //franch fr
    //spanish es-ES
    //english en-GB
    this.getBrowserLanguage()
//  this.$refs.checkboxTermsandconditions.internalValue = this.termsandcondition
  },

  computed: {
    heightDevice:{
      get: function() {
        return  screen.availHeight
      }
    },
    termsandcondition: {
      get: function() {
        return this.$store.state.isTermsAndCondition
      },
      set: function(newValue) {
        //set the new value in terms and condition
        this.$store.dispatch("setTermsAndCondition", newValue)
      }
    }
  },
  methods: {
    getBrowserLanguage: function () {
      switch(navigator.language) {
  case "it-IT":
    this.setLocale("it")// code block
    break;
  case "es-ES":
        this.setLocale("es")// code block
// code block
    break;
    case "ca":
     this.setLocale("cat") //code block
      break;
        case "fr":
     this.setLocale("fr")// code block
    break;
  default:
    this.setLocale("en")
      }
    },
    setLocale(selectedLanguage) {
        this.$store.dispatch("setPreferredLanguage", selectedLanguage)
        this.$i18n.locale = selectedLanguage;
        this.$vuetify.lang.current = selectedLanguage;
    },
    //change the page
    gotopage: function (page) {
      this.$router.push(page)
    },
    onChangePublicScope(){
      this.termsandcondition=!this.termsandcondition
    },

    selectedRole(selectedItems) {
      this.selectedRoleValue = selectedItems;
    },
    goToAuthorLogin(){
this.$router.push('login')
    },
    loginAsGuest() {
      this.error = "";
  //    EventBus.$emit("spinner", "on");
        this.$store.dispatch('setLoading',true)

      this.$axios
        .post(this.apiUrl + "/login", {
          user: "Guest",
          password: "GuestGuest"
        })
        .then(response => {
          // Handle success.
          if (response.status === 200) {
            this.submitted = true;
            response.data.location_id;
            this.$store
              .dispatch("setAccessToken", response.data.jwt)
              .then(()=> this.$store.dispatch("setUser", response.data.user))
//              .then(()=> this.$store.dispatch("setPreferredLanguage", response.data.user.language))
              .then(()=> this.$store.dispatch("setUserInfoStoredinLocalStorage",this.haveToSaveCredentials))
              .then(()=>this.$store.dispatch("increaseUserLoginCounter"))
              .then(()=> this.$store.dispatch('setLoading',false))
              
              .then(()=>this.$store.dispatch('setIsCreatedOrviewStories',1))
              .then(()=>this.$store.dispatch('setIsAllOrNearme',0))

              .then(()=> this.$router.push('home'))
          }
        })
        .catch(error => {
          if (error.status === 400) {

            this.$store.dispatch("setSnackbar", {
              color: 'red',
              text: this.$t('loginIncorrectCredentials'),
              active: true
            })
          }
          else {
            this.$store.dispatch("setSnackbar", {
              color: 'red',
              text: this.$t('loginIncorrectCredentials'),
              active: true
            })
           // EventBus.$emit("spinner", "off");
            // eslint-disable-next-line
            console.log(error);
          }
        });
    }
  }
};
</script>
<style>

.whiteFooter{
background-color:white;
opacity: 0.4;
position:absolute;
bottom:0px;
left:0px;
width:100%;
max-width: 700px;
margin:0px;
height:30vh;
z-index: 0;

}
.coverImg{
  background: url('~@/assets/welcomescreen.png') no-repeat center center fixed;
     -webkit-background-size: cover;
   -moz-background-size: cover;
   -o-background-size: cover;
   background-size: cover;
   height: 100vh;

}
.fontsize{
  font-size: 0.75rem!important;
  white-space: nowrap!important;
}
.btn2,.btn1{
  border-radius:999rem;
  text-transform: initial;
width: 240px;
}
.btnTermsAndCondition{
  text-transform:initial!important;
}
</style>
